import type { ReactNode } from 'react'
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material'
import { theme } from './theme'

type Props = {
  children: ReactNode
}

export const ThemeProvider = ({ children }: Props) => (
  <MuiThemeProvider theme={theme} defaultMode="system">
    <CssBaseline />
    {children}
  </MuiThemeProvider>
)
